// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__QG597","fullBleed":"styles_fullBleed__AwgKg"};